import type { MasterInput } from "../model/types";

/** Мінімум для ПІБ — дзеркалить і `Master`, і `MasterInput` (write-path). */
type NameParts = Pick<MasterInput, "firstName" | "middleName" | "lastName">;

/**
 * Єдиний форматер ПІБ майстра («Імʼя [По-батькові] Прізвище») для списку,
 * ідентифікаційного хедера й діалогів. Тримінг + відсікання порожніх частин, щоб
 * не плодити подвійні пробіли на опційному по батькові.
 */
export function masterFullName(m: NameParts): string {
  return [m.firstName, m.middleName, m.lastName]
    .map((s) => s.trim())
    .filter(Boolean)
    .join(" ");
}
